/* Common Imports */
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

/* Component Imports */
import { Typography } from "@material-ui/core";

/* Data Imports */
import AppConfig from "../../../AppConfig";

const useStyles = makeStyles((theme) => ({
  megaContainer: {
    backgroundColor: "#FAFAFA",
    padding: "1.5rem 0rem 1.5rem 0rem",
  },
  mainContainer: {
    margin: "5rem 8rem 5rem 8rem",
    [theme.breakpoints.down("sm")]: {
      margin: "0rem 2rem 0rem 2rem",
    },
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      justifyContent: "center",
      gap: "0rem",
    },
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: "2rem",
  },
  text: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    width: "60%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  heading: {
    margin: "0rem 0rem 1rem 0rem",
    fontWeight: 600,
    fontWeight: 600,
    color: "#0DB14B",
    fontSize: "2.125rem",
    lineHeight: "2.5rem",
    // [theme.breakpoints.down("sm")]: {
    //   fontSize: "1.75rem",
    //   lineHeight: "2.125rem",
    // },
    // [theme.breakpoints.down("xs")]: {
    //   fontSize: "1.75rem",
    //   lineHeight: "2.125rem",
    // },
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2rem",
    },
  },
  heading1: {
    width: "100%",
    fontWeight: 600,
    color: "#202020",
    fontSize: "2.125rem",
    lineHeight: "2.5rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.125rem",
    },
  },
  subHeading: {
    margin: "0rem 0rem 1rem 0rem",
    width: "100%",
    color: "#212121",
    fontWeight: 400,
    fontSize: "1.25rem",
    lineHeight: "2rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
      lineHeight: "1.625rem",
    },
  },
  illustrationSizer: {
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      height: "200px",
      width: "270px",
    },
    [theme.breakpoints.only("xs")]: {
      height: "260px",
      width: "350px",
    },
    [theme.breakpoints.only("sm")]: {
      height: "400px",
      width: "600px",
    },
    [theme.breakpoints.only("md")]: {
      height: "250px",
      width: "400px",
    },
    [theme.breakpoints.only("lg")]: {
      height: "400px",
      width: "500px",
    },
    [theme.breakpoints.only("xl")]: {
      height: "380px",
      width: "500px",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      height: "450px",
      width: "600px",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      height: "450px",
      width: "650px",
    },
  },
}));

const OriginSection = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.megaContainer}>
        <div className={classes.mainContainer}>
          <div className={classes.sectionContainer}>
            <div className={classes.text}>
              <Typography
                variant="h1"
                component="h1"
                className={classes.heading}
              >
                Origin
              </Typography>
              <Typography
                variant="body2"
                component="span"
                className={classes.subHeading}
              >
                Land is the foundation of human civilization - shaping empires, offering shelter, and holding enduring
                value. In a world of constant change, land remains one of the most secure and impactful investments you
                can make. It is not just property—it’s a timeless legacy.
              </Typography>
            </div>
            <div className={classes.animation}>
              <img
                src="/images/icons/heavie/index/plot.svg"
                alt={AppConfig.imageAltText}
                width={512}
                height={512}
                loading="eager"
                referrerPolicy="no-referrer"
                className={classes.illustrationSizer}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default OriginSection;
